((DetailSlider) => {
  'use strict';
  
  const options = {
    autoplay: true,
    autoPlaySpeed: 6000,
    arrows: true,
    dots: true
  };

  const initSlider = () => {
    // jquery because slick
    const $DetailSliderSlider = $('[data-detail-slider]');

    if ($DetailSliderSlider.hasClass('slick-slider')) return;
    $DetailSliderSlider.slick(options);
  };

  const initSlider2 = () => {
    const $DetailSliderSlider = $('[data-detail-slider-2]');
    const prevArrow = '<div class="slick-arrow slick-prev"><div class="slider--arrow"></div></div>';
    const nextArrow = '<div class="slick-arrow slick-next"><div class="slider--arrow"></div></div>';
    
    if ($DetailSliderSlider.hasClass('slick-slider')) return;
    $DetailSliderSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: true,
      infinite: false,
      prevArrow,
      nextArrow,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          },
        },
      ]
    });
  };

  const init = () => {
    initSlider();
    initSlider2();
  };

  DetailSlider.init = init;
})(window.DetailSlider = window.DetailSlider || {});